export default { selectedProjectId: { type: Number } };
